import { useState, useEffect } from 'react';
import { DeviceInfo } from '../types';

export const useDeviceDetection = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    platform: 'unknown',
    hasTouch: false,
    screenSize: { width: 0, height: 0 },
    orientation: 'portrait',
    connectionType: 'unknown'
  });

  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent;
      const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      // デバイスタイプ判定
      const isMobile = width < 768 && hasTouch;
      const isTablet = width >= 768 && width < 1024 && hasTouch;
      const isDesktop = width >= 1024 || !hasTouch;
      
      // プラットフォーム判定
      let platform: DeviceInfo['platform'] = 'unknown';
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        platform = 'ios';
      } else if (/Android/.test(userAgent)) {
        platform = 'android';
      } else {
        platform = 'desktop';
      }

      // 画面向き判定
      const orientation: DeviceInfo['orientation'] = width > height ? 'landscape' : 'portrait';

      // ネットワーク状況取得
      let connectionType: DeviceInfo['connectionType'] = 'unknown';
      if ('connection' in navigator) {
        const connection = (navigator as any).connection;
        if (connection && connection.effectiveType) {
          connectionType = connection.effectiveType;
        }
      }

      // Wi-Fi判定（簡易的）
      if ('connection' in navigator) {
        const connection = (navigator as any).connection;
        if (connection && connection.type === 'wifi') {
          connectionType = 'wifi';
        }
      }

      setDeviceInfo({
        isMobile,
        isTablet,
        isDesktop,
        platform,
        hasTouch,
        screenSize: { width, height },
        orientation,
        connectionType
      });
    };

    // 初回実行
    detectDevice();

    // イベントリスナー登録
    const handleResize = () => {
      // リサイズ時に再判定（デバウンス処理）
      setTimeout(detectDevice, 100);
    };

    const handleOrientationChange = () => {
      // 画面回転時に再判定
      setTimeout(detectDevice, 200);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);
    
    // ネットワーク変更監視
    if ('connection' in navigator) {
      const connection = (navigator as any).connection;
      if (connection) {
        connection.addEventListener('change', detectDevice);
      }
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
      
      if ('connection' in navigator) {
        const connection = (navigator as any).connection;
        if (connection) {
          connection.removeEventListener('change', detectDevice);
        }
      }
    };
  }, []);

  return deviceInfo;
}; 